import { motion } from 'framer-motion'
import { Check, X } from 'lucide-react'
import CascadeSpinner from './CascadeSpinner'

interface Props {
  label: string
  status: 'running' | 'done' | 'error'
  detail?: string
}

export default function AgentStatusLine({ label, status, detail }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.15 }}
      className="flex items-center gap-2 py-0.5 pl-1"
    >
      {status === 'done' && (
        <Check className="w-3.5 h-3.5 text-emerald-500/60 shrink-0" />
      )}
      {status === 'running' && (
        <CascadeSpinner className="text-cyan-400 shrink-0" />
      )}
      {status === 'error' && (
        <X className="w-3.5 h-3.5 text-red-400 shrink-0" />
      )}
      <span className={`font-mono text-sm ${
        status === 'done' ? 'text-slate-500'
        : status === 'running' ? 'text-slate-300'
        : 'text-red-400/80'
      }`}>
        {label}
      </span>
      {detail && (
        <span className={`font-mono text-xs ${status === 'error' ? 'text-red-400/60' : 'text-slate-500'}`}>
          {detail}
        </span>
      )}
    </motion.div>
  )
}
